import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import DevelopmentBanner from "./DevelopmentBanner";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // TODO: Replace with your actual form submission endpoint
    // This could be a backend API, Netlify Forms, EmailJS, or similar service
    try {
      setStatus("Sending...");
      
      // Example: Using fetch to send to your backend
      // const response = await fetch('/api/contact', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(formData),
      // });

      // For now, just show a placeholder message
      console.log("Form data:", formData);
      setStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
      setTimeout(() => setStatus(""), 5000);
    } catch (error) {
      setStatus("error");
      console.error("Error sending message:", error);
      setTimeout(() => setStatus(""), 5000);
    }
  };

  return (
    <div className="contact-page">
      <DevelopmentBanner />
      <div className="title">
        <h2 className="heading">let's chat.</h2>
        <p className="section-subtitle">Questions, ideas, or just wanna say hi?</p>
      </div>

      <div className="contact-container">
        <div className="contact-content">
          <p>
            Got an exciting project? A wild idea? Or just want to geek out about tech and creative projects?
            Drop me a message and let's see what we can create together!
          </p>

          <div className="contact-methods">
            <div className="contact-method">
              <h3>Email</h3>
              <a href="mailto:joe@joerickard.co.uk">joe@joerickard.co.uk</a>
            </div>
            <div className="contact-method">
              <h3>Phone</h3>
              <p>TODO: Add phone number</p>
            </div>
            <div className="contact-method">
              <h3>Location</h3>
              <p>London</p>
            </div>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          {status === "success" && (
            <Alert severity="success">
              Thank you! Your message has been sent successfully. I'll get back to you soon.
            </Alert>
          )}
          {status === "error" && (
            <Alert severity="error">
              There was an error sending your message. Please try again or email me directly.
            </Alert>
          )}

          <TextField
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            margin="normal"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "var(--accent-color1)",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "var(--accent-color1)",
                opacity: 0.7,
              },
            }}
          />

          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            margin="normal"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "var(--accent-color1)",
              },
            }}
          />

          <TextField
            fullWidth
            label="Subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
            margin="normal"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "var(--accent-color1)",
              },
            }}
          />

          <TextField
            fullWidth
            label="Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            multiline
            rows={6}
            margin="normal"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "var(--accent-color1)",
              },
            }}
          />

          <Button
            type="submit"
            variant="contained"
            className="submit-button"
            sx={{
              mt: 2,
              backgroundColor: "var(--primary-color2)",
              color: "var(--accent-color1)",
              fontWeight: "bold",
              padding: "10px 30px",
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "var(--primary-color3)",
              },
            }}
          >
            Send Message
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
